import React from 'react';
import { DashboardV2 } from '../../components/dashboard-v2';
import Bread from '../../components/breadcrumb';

const routeDashboardV2 = [
  {
    path: '/',
    breadcrumbName: 'Inicio',
  },
  {
    breadcrumbName: 'Dashboard Personalizado',
  },
];

const DashboardV2Page = () => {
  return (
    <div className="dashboard-v2-page">
      <Bread routes={routeDashboardV2} />
      <DashboardV2 />
    </div>
  );
};

export default DashboardV2Page;
